<template>
    <v-card>
        <v-row cols="3">
            <v-col class="mx-4 py-0">
                <v-card-title class="justify-center">Overview of discount codes</v-card-title>
            </v-col>
        </v-row>
        <v-divider/>
        <v-card-text>
            <v-row cols="12">
                <v-col class="pt-2" cols=2>
                    <v-text-field v-model="search" label="Search discount code" single-line hide-details dense prepend-icon="mdi-magnify"></v-text-field>
                </v-col>
                <v-col class="pt-2" cols=1>
                    <v-select v-model="unique" label="Unique" :items="unique_items" item-value="value" item-text="label" dense @change="updateUnique"></v-select>
                </v-col>
                <!-- <v-col class="pt-2" cols=1>
                    <v-select v-model="company" label="Company" :items="company_items" item-value="value" item-text="label" dense @change="updateCompany"></v-select>
                </v-col> -->
                <v-col class="pt-2" cols=1>
                    <v-select v-model="country" label="Country" :items="country_items" item-value="value" item-text="label" dense @change="updateCountry"></v-select>
                </v-col>
                <v-col class="pt-2" cols=6>
                    
                </v-col>
                <v-col class="pt-2" cols=2>
                    <btn_component type="text" text="Add discount code" color="primary" tooltip="Add a discount code" size="small" data="" @actionClick="addDiscount" /> 
                </v-col>
            </v-row>
        </v-card-text>
        <akcd_addAkcd ref="akcd_addAkcd" @refreshList="refreshList"/>
    </v-card>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import akcd_addAkcd from "@/components/syst/ref/akcd/akcd_addAkcd.vue";

    export default {
        components: {
            btn_component,
            akcd_addAkcd,
        },    
        data() {
            return {
                search: "",

                unique: "",
                unique_items:[{
                    value: "",
                    label: "All"
                }, {
                    value: "Yes",
                    label: "Yes"
                }, {
                    value: "No",
                    label: "No"
                }],

                country: "",
                country_items:[{
                    value: "",
                    label: "All"
                }, {
                    value: "AT",
                    label: "AT"
                }, {
                    value: "BE",
                    label: "BE"
                }, {
                    value: "DE",
                    label: "DE"
                }, {
                    value: "FR",
                    label: "FR"
                }, {
                    value: "NL",
                    label: "NL"
                }],

                company: "",
                company_items:[{
                    value: "",
                    label: "All"
                }, {
                    value: "VFY",
                    label: "VFY"
                }, {
                    value: "IH",
                    label: "IH"
                }],
            }
        }, 
        watch: {
            search() {
                this.updateSearch();
            }
        },   
        methods: {
            updateSelection(selectionType, selectionValue) {
                this.$emit("updateSelection", selectionType, selectionValue);
            },  
            updateSearch() {
                this.updateSelection("search", this.search);
            },  
            updateUnique() {
                this.updateSelection("unique", this.unique);
            },  
            updateCompany() {
                this.updateSelection("company", this.company);
            },  
            updateCountry() {
                this.updateSelection("country", this.country);
            }, 
            refreshList() {
                this.updateSelection("refresh", "");
            },
            addDiscount() {
                this.$refs.akcd_addAkcd.openDialog();
            },
        }
    }
</script>

<style scoped> 

</style>